
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetomumbaidarshanbus() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Darshan Bus On Rent',
        heading: 'Amruta Travels: Pune to Mumbai Darshan Bus On Rent',
        headingDescription: 'Amruta Travels offers Pune to Mumbai Darshan Bus on Rent, providing a reliable and comfortable transportation solution for your city exploration. Whether you are planning a family outing, corporate event, or group tour, our well-maintained buses ensure a smooth and enjoyable journey to Mumbai is iconic landmarks. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your Mumbai Darshan simple and stress-free. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. Book your Pune to Mumbai Darshan Bus with Amruta Travels and embark on a journey of comfort and discovery!',


        top: 'Top Places to Visit in Mumbai with Amruta Travels',
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "An iconic monument built during the British Raj, the Gateway of India overlooks the Arabian Sea and is a popular starting point for exploring Mumbai. It also serves as a hub for ferry rides to Elephanta Caves."
  },
  {
    "title": "Marine Drive",
    "description": "Known as the Queen’s Necklace for its sparkling night view, Marine Drive is a 3.6-km-long boulevard along the Arabian Sea, ideal for evening strolls, jogs, and sunset views."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "A UNESCO World Heritage Site, this grand railway station is a blend of Victorian Gothic and Indian architecture. It's a functional transit hub and an architectural marvel."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these ancient rock-cut caves house intricately carved sculptures of Lord Shiva. A ferry ride from the Gateway of India takes visitors to this UNESCO World Heritage Site."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Dedicated to Lord Ganesha, this temple in Prabhadevi is one of Mumbai’s most visited religious sites, frequented by celebrities and commoners alike for blessings."
  },
  {
    "title": "Colaba Causeway",
    "description": "A bustling shopping street near the Gateway of India, Colaba Causeway offers everything from trendy clothes and jewelry to antiques and street food — perfect for a local shopping experience."
  },
  {
    "title": "Juhu Beach",
    "description": "One of Mumbai's most famous beaches, Juhu Beach is a hotspot for relaxing, street food like pav bhaji and bhel puri, and celebrity spotting near the nearby residential areas."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built on an islet off the coast of Worli, this Indo-Islamic shrine is accessible via a narrow causeway and draws visitors of all faiths for its spiritual ambiance and scenic setting."
  },
  {
    "title": "Chor Bazaar",
    "description": "One of the oldest flea markets in India, Chor Bazaar is known for antique treasures, Bollywood posters, vintage furniture, and rare collectibles. A paradise for curious shoppers and history buffs."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "Located in Gorai near EsselWorld, this massive golden pagoda is a meditation dome built in honor of Sayagyi U Ba Khin. It promotes peace and features the world's largest stone dome built without supporting pillars."
  }
],



 "services": [
    {
      "name": "Pune to Mumbai Darshan Bus on Rent",
      "description": "Amruta Travels offers comfortable and well-maintained buses for your journey from Pune to Mumbai for sightseeing. Whether you are visiting iconic places like Gateway of India, Marine Drive, or Elephanta Caves, our buses provide a comfortable, air-conditioned ride. We cater to all group sizes, ensuring you have a smooth and relaxing experience while exploring Mumbai’s top attractions."
    },
    {
      "name": "Pune to Mumbai International Airport Mini Bus on Rent",
      "description": "Travel in comfort with Amruta Travels’ mini bus rental service for airport transfers from Pune to Mumbai International Airport. Our air-conditioned mini buses are ideal for small groups, offering ample luggage space and a comfortable journey to catch your flights or pick up arriving guests."
    },
    {
      "name": "Pune to Navi Mumbai Bus On Rent",
      "description": "For those traveling to Navi Mumbai from Pune, Amruta Travels offers reliable and comfortable bus rental services. Whether it’s for corporate trips, family outings, or airport transfers, our buses ensure a smooth journey with experienced drivers and air-conditioned interiors for maximum comfort."
    },
    {
      "name": "Pune to Thane Bus on Rent",
      "description": "Amruta Travels provides buses for rent from Pune to Thane for a variety of purposes including group tours, corporate outings, and personal trips. Our buses are spacious and air-conditioned, with comfortable seating and reliable drivers to ensure you have a safe and pleasant journey."
    },
    {
      "name": "Pune to Mumbai Airport Urbania Bus on Rent",
      "description": "For those looking to travel in luxury, Amruta Travels offers the Force Urbania bus for rent from Pune to Mumbai Airport. This luxury bus offers high-end amenities, comfortable seating, and ample space for both passengers and luggage, making it perfect for group travel to the airport in style."
    },
    {
      "name": "Pune to Mumbai Airport Drop Bus on Rent",
      "description": "Traveling to Mumbai Airport from Pune? Our Pune to Mumbai Airport drop-off bus service ensures a timely and comfortable journey. Our buses are air-conditioned and spacious, ideal for families, corporate groups, or wedding guests traveling to the airport for an international or domestic flight."
    },
    {
      "name": "Pune to Mumbai Domestic Airport Bus on Rent",
      "description": "If you're flying out from Mumbai’s Domestic Airport, Amruta Travels provides reliable bus rental services from Pune to the airport. Whether it's a family trip or corporate travel, our buses offer comfortable, air-conditioned interiors, ensuring you get to the airport on time and in comfort."
    },
    {
      "name": "Pune to Panvel Bus On Rent",
      "description": "Looking to travel from Pune to Panvel? Amruta Travels offers buses on rent for your journey. Perfect for both personal and corporate travel, our buses ensure comfort with spacious, air-conditioned seating and expert drivers to make your trip as smooth as possible."
    },
    {
      "name": "Pune to Mumbai Round Trip Bus on Rent",
      "description": "For a round trip from Pune to Mumbai, Amruta Travels offers convenient bus rental services. Whether you're attending an event, exploring the city, or visiting family, our buses provide you with the flexibility to make the most of your round trip with comfort and safety."
    },
    {
      "name": "Pune to Mumbai Events Bus on Rent",
      "description": "If you're attending an event in Mumbai, such as a wedding, conference, or cultural gathering, Amruta Travels provides buses on rent for seamless travel from Pune to Mumbai. Our buses are designed to provide comfort and convenience for event attendees, with air-conditioned interiors and plenty of space for luggage and guests."
    },
    {
      "name": "Pune to Dadar Mini Bus on Rent",
      "description": "Traveling to Dadar from Pune? Amruta Travels offers mini bus rentals for this popular route. Our mini buses are perfect for small to medium-sized groups, providing air-conditioned comfort and a smooth ride to one of Mumbai’s busiest and most iconic areas."
    },
    {
      "name": "Pune to Bandra Terminus Bus on Rent",
      "description": "If you're catching a train from Bandra Terminus, Amruta Travels offers bus rentals from Pune to Bandra Terminus. Our buses are comfortable, air-conditioned, and reliable, ensuring you reach the station on time without any hassle. Perfect for group travel or family trips to the station."
    },
    {
      "name": "Pune Mumbai Tempo Traveller Hire",
      "description": "For a more personalized and intimate travel experience, Amruta Travels provides Tempo Traveller rentals for your journey from Pune to Mumbai. Ideal for small groups, families, or friends, our Tempo Travellers offer comfort, convenience, and flexibility with ample seating and air-conditioning, ensuring a pleasant journey to Mumbai."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Darshan Bus on Rent", "Pune to Mumbai International Airport Mini Bus on Rent"],
    ["Pune to Navi Mumbai Bus On Rent", "Pune to Thane Bus on Rent"],
    ["Pune to Mumbai Airport Urbania Bus on Rent", "Pune to Mumbai Airport Drop Bus on Rent"],
    ["Pune to Mumbai Domestic Airport Bus on Rent", "Pune to Panvel Bus On Rent"],
    ["Pune to Mumbai Round Trip Bus on Rent", "Pune to Mumbai Events Bus on Rent"],
    ["Pune to Dadar Mini Bus on Rent", "Pune to Bandra Terminus Bus on Rent"],
    ["Pune Mumbai Tempo Traveller Hire", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Hassle-Free Travel to Mumbai",
    "WhyChoosedescription": "Amruta Travels offers Pune to Mumbai Darshan Bus on Rent, ensuring a comfortable, smooth, and relaxing journey to explore Mumbai’s iconic landmarks. Our buses are equipped with spacious seating, air conditioning, and modern amenities to ensure that your travel experience is enjoyable from start to finish. Whether you're visiting religious sites like the Siddhivinayak Temple, exploring tourist spots like Gateway of India, or attending a cultural event, we provide reliable and comfortable transportation."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimages, Group Tours, and Sightseeing",
    "WhyChoosedescription": "Our buses are perfect for groups traveling to Mumbai for religious pilgrimages, sightseeing tours, or group events. From the famous temples and beaches to the bustling markets and museums, we ensure that your entire group travels together in comfort. The spacious interiors and comfortable seating make it easier for your group to relax and enjoy the sights of Mumbai with ease. Whether it's a one-day tour or a weekend getaway, we cater to all your group travel needs."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for a Safe Journey",
    "WhyChoosedescription": "Our drivers are highly experienced, courteous, and knowledgeable about the Pune to Mumbai route. They ensure that your journey is safe, timely, and smooth. With years of experience on the roads, they are adept at handling group transportation while adhering to the highest safety standards. Our drivers are trained to prioritize passenger comfort and safety, making sure that every trip is stress-free and enjoyable for all."
  },
  {
    "WhyChooseheading": "Affordable, Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Amruta Travels offers affordable pricing for Pune to Mumbai Darshan Bus on Rent, with clear, upfront rates and no hidden charges. Whether you're planning a short trip or a longer stay, we provide a cost-effective solution for all your group travel needs. Our transparent pricing ensures that you can plan your trip without worrying about unexpected costs, making it easier to manage your travel expenses."
  },
  {
    "WhyChooseheading": "Well-Maintained Buses for a Comfortable Ride",
    "WhyChoosedescription": "Our buses are regularly maintained and cleaned to provide the highest standards of comfort and hygiene. We take great pride in ensuring that every vehicle in our fleet is in perfect working condition, so you can enjoy a smooth and safe journey. From the comfortable seating to the cleanliness of the bus, we strive to make every part of your trip as enjoyable as possible."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Options Across Pune",
    "WhyChoosedescription": "We understand that every traveler’s needs are different. That’s why we offer flexible pick-up and drop-off locations throughout Pune, whether you're traveling from your home, office, or hotel. We ensure that your travel is as convenient as possible by accommodating your preferred locations and time schedules. Whether you're departing early in the morning or late in the evening, we make sure your journey starts and ends at your convenience."
  },
  {
    "WhyChooseheading": "Customizable Itinerary for Your Group’s Needs",
    "WhyChoosedescription": "Our Pune to Mumbai Darshan Bus on Rent comes with a fully customizable itinerary, allowing you to tailor your trip according to your preferences. Whether you want to visit specific tourist destinations, attend multiple events, or make additional stops along the way, we can adapt the itinerary to your needs. Our goal is to provide a personalized and flexible travel experience that ensures you get the most out of your time in Mumbai."
  },
  {
    "WhyChooseheading": "Easy Booking and Dedicated Support",
    "WhyChoosedescription": "Booking your Pune to Mumbai Darshan Bus with Amruta Travels is simple and efficient. You can easily book online, contact our customer support, or visit our office for assistance. Our friendly and professional team is available to help you with every step of the booking process, ensuring that your journey is organized smoothly. We also provide ongoing support during your trip to address any questions or issues that may arise."
  }
]
























    }

const faqData = [
  {
    question: 'How can I rent a bus for a Pune to Mumbai Darshan trip?',
    answer: 'Renting a bus for your Pune to Mumbai Darshan trip with Amruta Travels is simple. You can book online, call our support team, or visit our office. We’ll assist you in selecting the right bus based on your group size and travel preferences.',
  },
  {
    question: 'What types of buses are available for the Pune to Mumbai Darshan trip?',
    answer: 'We offer a variety of buses, including 32, 35, 45, and 50-seater options. Whether you need a standard or luxury bus, we have buses to suit your group size and provide a comfortable, hassle-free journey.',
  },
  {
    question: 'How long does it take to travel from Pune to Mumbai for Darshan?',
    answer: 'The travel time from Pune to Mumbai is approximately 3 to 4 hours, depending on traffic conditions. Our experienced drivers will ensure a smooth and timely journey to visit key darshan spots in Mumbai.',
  },
  {
    question: 'Are the buses comfortable for the journey from Pune to Mumbai?',
    answer: 'Yes, all our buses are well-maintained and equipped with comfortable seating, air conditioning, and spacious interiors. You will have a pleasant and comfortable ride throughout your darshan trip to Mumbai.',
  },
  {
    question: 'Can I book a bus for a one-day Mumbai Darshan trip?',
    answer: 'Yes, we offer flexible booking options for both one-day and multi-day trips to Mumbai for darshan. We will customize the itinerary based on the temples and locations you want to visit.',
  },
  {
    question: 'Do you offer both standard and luxury buses for the Pune to Mumbai Darshan trip?',
    answer: 'Yes, we offer both standard and luxury buses. Our luxury buses come with additional amenities such as premium seating, air conditioning, and more, ensuring a luxurious travel experience for your Mumbai Darshan.',
  },
  {
    question: 'How much does it cost to rent a bus for the Pune to Mumbai Darshan trip?',
    answer: 'The cost depends on the bus size, duration of the trip, and any additional services you may require. Please contact us for a customized quote based on your specific travel details.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. Share your preferred locations with us, and we’ll plan the best route for your Pune to Mumbai Darshan trip.',
  },
  {
    question: 'Why should I choose Amruta Travels for Pune to Mumbai Darshan bus rental?',
    answer: 'Amruta Travels offers reliable, comfortable, and safe bus services for your Pune to Mumbai Darshan trip. Our buses are well-maintained, and our experienced drivers ensure a smooth and safe journey. We focus on customer satisfaction and strive to make your darshan experience memorable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sanjay Kulkarni',
    role: 'Corporate Travel Manager, Pune',
    text: 'We rented a 45-seater bus from Amruta Travels for a corporate darshan trip to Mumbai. The bus was comfortable, clean, and the driver was courteous. The trip was well-organized, and the service was excellent!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Leela Joshi',
    role: 'Pilgrimage Coordinator, Pune',
    text: 'We hired a 35-seater bus for a family darshan trip to Mumbai. The bus was spacious, air-conditioned, and well-maintained. The driver ensured our safety and comfort throughout the journey. We had a wonderful experience with Amruta Travels.',
    rating: 5,
  },
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Darshan Bus on Rent",
  "image": "https://bushireinpune.com/assets/images/pune-to-mumbai-darshan-bus-on-rent.jpg",
  "description": "Book a bus for a seamless and comfortable trip from Pune to Mumbai. Visit major attractions or travel to Mumbai Airport, Navi Mumbai, Thane, and more. Choose from mini buses, tempo travellers, and larger buses for group travel with Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4321"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5499", // Adjust the price accordingly
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-mumbai-darshan-bus-on-rent"
  }
};



    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Mumbai Darshan Bus on Rent | Affordable & Comfortable Travel | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book a bus for your Pune to Mumbai Darshan trip. Comfortable buses for airport drops, Mumbai sightseeing, and events. Choose from various bus options for group travel with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/28.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaidarshanbus;